import { forwardRef } from "react";
const SvgUp = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M8.00049 2.99995L11.536 6.53548M8.00049 2.99995L4.46495 6.53548M8.00049 2.99995L8.00049 12.8994" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
const ForwardRef = forwardRef(SvgUp);
export default ForwardRef;